import { createFileRoute } from '@tanstack/react-router';
import UserGroups from '../../../administration/src/components/UserGroups';

export const Route = createFileRoute('/_secured/administration/user-groups')({
  component: UserGroups,
});
